<template>
  <div class="globe-loader" :class="{ 'globe-loader-overlay': overlay }">
    <div class="globe-loader-stage">
      <svg class="globe-loader-svg" viewBox="0 0 160 160" aria-hidden="true">
        <circle class="globe-loader-orbit" cx="80" cy="80" r="70" />
        <g class="globe-loader-grid">
          <line x1="46" y1="68" x2="114" y2="68" />
          <line x1="44" y1="80" x2="116" y2="80" />
          <line x1="46" y1="92" x2="114" y2="92" />
          <ellipse cx="80" cy="80" rx="14" ry="36" />
          <ellipse cx="80" cy="80" rx="28" ry="36" />
        </g>
        <circle class="globe-loader-globe" cx="80" cy="80" r="36" />
      </svg>
      <div class="globe-loader-flight">
        <Plane class="globe-loader-plane" :size="20" />
      </div>
    </div>
    <div class="globe-loader-title">
      {{ title }}
      <span class="globe-loader-dots">
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </span>
    </div>
    <div v-if="subtitle" class="globe-loader-subtitle">{{ subtitle }}</div>
  </div>
</template>

<script>
import { Plane } from 'lucide-vue';

// Ladeanzeige mit Globus, den ein Flieger umkreist
export default {
  name: 'GlobeLoader',
  components: { Plane },
  props: {
    title: { type: String, default: 'Daten werden geladen' },
    subtitle: { type: String, default: null },
    // Legt den Lader deckend über einen Container mit position-relative
    overlay: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.globe-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  text-align: center;
}
.globe-loader-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  background: var(--surface);
}
.globe-loader-stage {
  position: relative;
  width: 160px;
  height: 160px;
  margin-bottom: 24px;
}
.globe-loader-svg {
  width: 100%;
  height: 100%;
  fill: none;
}
.globe-loader-orbit {
  stroke: var(--border-strong);
  stroke-width: 1.5;
  stroke-dasharray: 4 4;
}
.globe-loader-grid {
  stroke: var(--primary-light);
  stroke-width: 1.5;
}
.globe-loader-globe {
  stroke: var(--primary);
  stroke-width: 2.5;
}
.globe-loader-flight {
  position: absolute;
  inset: 0;
  animation: globe-loader-orbit 3s linear infinite;
}
.globe-loader-plane {
  position: absolute;
  top: 0;
  left: 70px;
  color: var(--primary);
  fill: var(--primary);
  transform: rotate(45deg);
}
.globe-loader-title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: var(--text);
}
.globe-loader-subtitle {
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
  color: var(--text-muted);
}
.globe-loader-dots span {
  animation: globe-loader-dot 1.4s infinite;
  opacity: 0.2;
}
.globe-loader-dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.globe-loader-dots span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes globe-loader-orbit {
  to {
    transform: rotate(360deg);
  }
}
@keyframes globe-loader-dot {
  0%,
  80%,
  100% {
    opacity: 0.2;
  }
  40% {
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .globe-loader-flight,
  .globe-loader-dots span {
    animation: none;
  }
  .globe-loader-dots span {
    opacity: 1;
  }
}
</style>
